/**
 * Reduced motion (backlog 8, DELOWO_DESIGN §7). CSS animations and transitions are cut by the
 * global rule at the end of custom_delowo.css; scripted scrolls ask here instead.
 * SSR-safe: on the server (no window / matchMedia) motion is not reduced.
 */
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * @returns {boolean} true when the visitor asked the system for reduced motion
 */
export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  !!window.matchMedia(REDUCED_MOTION_QUERY)?.matches;

/**
 * The `behavior` for scrollTo / scrollBy / scrollIntoView calls that would scroll smoothly.
 *
 * @returns {'auto'|'smooth'} 'auto' with reduced motion, otherwise 'smooth'
 */
export const smoothScrollBehavior = () => (prefersReducedMotion() ? 'auto' : 'smooth');
